import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Home,
  Calendar,
  Users,
  MessageCircle,
  BarChart2,
  MoreHorizontal,
} from "lucide-react";

const TABS = [
  { id: "home", label: "Home", Icon: Home, path: "/" },
  { id: "events", label: "Events", Icon: Calendar, path: "/events" },
  { id: "friends", label: "Friends", Icon: Users, path: "/friends" },
  { id: "chat", label: "Chat", Icon: MessageCircle, path: "/chat" },
  { id: "stats", label: "Stats", Icon: BarChart2, path: "/stats" },
  { id: "more", label: "More", Icon: MoreHorizontal, path: "/more" },
];

export function BottomNav() {
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <nav className='md:hidden fixed bottom-0 left-1/2 -translate-x-1/2 w-full max-w-mobile bg-white border-t border-gray-200 z-40 safe-bottom'>
      <div className='flex items-center justify-around px-1 py-1'>
        {TABS.map(({ id, label, Icon, path }) => {
          const isActive =
            path === "/"
              ? location.pathname === "/"
              : location.pathname.startsWith(path);
          return (
            <button
              key={id}
              onClick={() => navigate(path)}
              className={[
                "flex flex-col items-center gap-0.5 px-2 py-1.5 rounded-xl min-w-[48px]",
                "transition-colors active:scale-95",
                isActive
                  ? "text-primary-800"
                  : "text-gray-400 hover:text-gray-600",
              ].join(" ")}
            >
              <Icon size={22} strokeWidth={isActive ? 2.5 : 1.8} />
              <span
                className={`text-[10px] font-medium ${isActive ? "text-primary-800" : ""}`}
              >
                {label}
              </span>
            </button>
          );
        })}
      </div>
    </nav>
  );
}
